import styled from 'styled-components';
import {MAP_LAYER_Z_INDEX} from '@/map/constants';
import {StaticMarker} from '@/map/modules';
import MarkerIcon from './assets/analysis-point-marker.svg';

interface IProps {
  map: naver.maps.Map;
  position: naver.maps.MarkerOptions['position'];
}

export const AnalysisCenterMarker = ({position, map}: IProps) => {
  return (
    <StaticMarker map={map} position={position}>
      <Root>
        <img src={MarkerIcon} width={44} height={44} alt="위치 마커" />
      </Root>
    </StaticMarker>
  );
};

const Root = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: ${MAP_LAYER_Z_INDEX.LOCATION};
  pointer-events: none;
  width: 44px;
  height: 44px;
  transform: translate(-50%, calc(-50% - 20px));
`;
